import Layout from "../components/layout"
import MemberQuiz from "../components/MemberQuiz"
import React from "react"
import SEO from "../components/seo"
import styles from "../styles/ethosEvaluation.module.scss"

//Static Home Page

class EthosMemberPage extends React.Component {
  constructor(props) {
    super()
    this.ethosQuizElement = React.createRef()
    //this.handler = this.handler.bind(this)

    this.state = {
      submitted: true,
      hideIntro: false,
      email: '',
      name: '',
      lastName: '',
    }
  }

  handleClick(emailAddress, fnameVal, lnameVal) {
    this.setState({
      submitted: true,
      email: emailAddress,
      name: fnameVal,
      lastName: lnameVal,
      hideIntro: true,
    })
    this.ethosQuizElement.current.displayProgressBar()
  }

  handler() {
    
  }

  render() {
    return (
      <Layout>
        <SEO title="Ethos Evaluation" description="" />
        <>
        {/*
          {!this.state.hideIntro ? (
            <section className={styles.intro}>
              <div className={styles.intro_img}>
                <iframe
                  src="https://player.vimeo.com/video/453482635"
                  width="640"
                  height="360"
                  frameborder="0"
                  width="700"
                  height="564"
                  frameBorder="0"
                  allow="autoplay; fullscreen"
                ></iframe>
              </div>
              <div className={styles.intro_txt}>
                <p>
                Before you can access the Empowered Community, you need to take your free
                  <span class="orange bold"> Ethos evaluation</span>!
                </p>
              </div>
            </section>
          ) : (
            ""
          )}
 */}
       
        </>
        <div>
          <MemberQuiz
            handleNext={this.handler}
            ref={this.ethosQuizElement}
            email={this.state.email}
            lastName={this.state.lastName}
            name={this.state.name}
          />
        </div>
      </Layout>
    )
  }
}

export default EthosMemberPage
